import React, { useEffect } from "react";
import { Button } from "antd";
import {
  CommentOutlined,
  MailOutlined,
  LinkOutlined,
  GlobalOutlined,
  RobotOutlined,
} from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import {
  trackAddonLockCtaClicked,
  trackAddonLockViewed,
} from "util/productAnalytics";
import styles from "../Sonic/style.module.scss";

const SONIC_PROSPECT_PRODUCT_URL = "https://pivony.com/products/sonic-prospect";
const SONIC_PROSPECT_SIGNUP_URL =
  "https://app.pivony.com/signup?product=sonic-prospect&utm_source=app.pivony.com&utm_medium=console&utm_campaign=sonic-prospect-lock";

const SonicProspectLockPage = ({ theme = "light" }) => {
  const { t } = useTranslation();

  useEffect(() => {
    trackAddonLockViewed("sonic_prospect");
  }, []);

  return (
    <div
      className={`${styles.sonicLockPage} ${
        theme === "dark" ? styles.sonicLockPageDark : styles.sonicLockPageLight
      }`}
    >
      <div className={styles.sonicLockBackground}>
        <div className={styles.sonicLockGrid} />
        <div className={styles.sonicLockOrbOne} />
        <div className={styles.sonicLockOrbTwo} />
        <div className={styles.sonicLockCardGhostOne}>
          <GlobalOutlined />
          <span>{t("sonic_prospect_lock.ghost_embed")}</span>
          <strong>{t("sonic_prospect_lock.ghost_live")}</strong>
        </div>
        <div className={styles.sonicLockCardGhostTwo}>
          <RobotOutlined />
          <span>{t("sonic_prospect_lock.ghost_kb")}</span>
          <strong>{t("sonic_prospect_lock.ghost_ai")}</strong>
        </div>
        <div className={styles.sonicLockRuleGhost}>
          <span>{t("sonic_prospect_lock.ghost_visitor")}</span>
          <span>{t("sonic_prospect_lock.ghost_answer")}</span>
          <span>{t("sonic_prospect_lock.ghost_lead")}</span>
        </div>
      </div>
      <div className={styles.sonicLockModal}>
        <div className={styles.sonicLockIcon}>
          <CommentOutlined />
        </div>
        <p className={styles.sonicLockEyebrow}>{t("sonic_prospect_lock.eyebrow")}</p>
        <h1>{t("sonic_prospect_lock.heading")}</h1>
        <p className={styles.sonicLockText}>{t("sonic_prospect_lock.body")}</p>
        <div className={styles.sonicLockActions}>
          <Button
            type="primary"
            size="large"
            icon={<MailOutlined />}
            href="mailto:hello@pivony.com?subject=Sonic%20Prospect%20Activation"
            className={styles.sonicLockCtaPrimary}
            onClick={() => trackAddonLockCtaClicked("sonic_prospect", "email")}
          >
            {t("product_lock.talk_to_sales")}
          </Button>
          <Button
            size="large"
            icon={<LinkOutlined />}
            href={SONIC_PROSPECT_PRODUCT_URL}
            target="_blank"
            rel="noopener noreferrer"
            className={styles.sonicLockCtaSecondary}
            onClick={() =>
              trackAddonLockCtaClicked("sonic_prospect", "read_more")
            }
          >
            {t("product_lock.upgrade_demo")}
          </Button>
        </div>
        <p className={styles.sonicLockText} style={{ marginTop: 16, fontSize: 13 }}>
          <a href={SONIC_PROSPECT_SIGNUP_URL}>{t("sonic_prospect_lock.start_free")}</a>
        </p>
      </div>
    </div>
  );
};

export default SonicProspectLockPage;
